(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PropertySearch', PropertySearch);

    PropertySearch.$inject = ['$resource'];

    function PropertySearch ($resource) {
        var service = $resource('api/property/search/:search', {}, {
            'query': {method: 'GET', isArray: true, ignoreLoadingBar: true},
            'get': {
                method: 'GET',
                isArray: true,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();
